import type { ReferenciaResponse } from '@/api/generated/model';

/**
 * Rótulos dos enums do catálogo.
 *
 * Ficam aqui, e não espalhados nos componentes, porque a faixa de referência
 * aparece em três lugares (lista, formulário, confirmação de exclusão) e uma
 * espécie escrita diferente em cada um é ruído puro.
 */
export const ESPECIES = [
  'CANINO',
  'FELINO',
  'EQUINO',
  'BOVINO',
  'SUINO',
  'CAPRINO',
  'OVINO',
  'AVE',
  'REPTIL',
  'ROEDOR',
  'OUTRO',
] as const;

export type Especie = (typeof ESPECIES)[number];

export const ROTULO_ESPECIE: Record<Especie, string> = {
  CANINO: 'Canino',
  FELINO: 'Felino',
  EQUINO: 'Equino',
  BOVINO: 'Bovino',
  SUINO: 'Suíno',
  CAPRINO: 'Caprino',
  OVINO: 'Ovino',
  AVE: 'Ave',
  REPTIL: 'Réptil',
  ROEDOR: 'Roedor',
  OUTRO: 'Outro',
};

export const SEXOS = ['MACHO', 'FEMEA', 'INDEFINIDO'] as const;
export type Sexo = (typeof SEXOS)[number];

export const ROTULO_SEXO: Record<Sexo, string> = {
  MACHO: 'Macho',
  FEMEA: 'Fêmea',
  INDEFINIDO: 'Indefinido',
};

/** "3,5 a 8,25" · "até 8" · "a partir de 3,5" · o texto qualitativo. */
export function descreverFaixa(referencia: ReferenciaResponse): string {
  if (referencia.textoReferencia) return referencia.textoReferencia;

  const numero = (v: number) => v.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
  const { minimo, maximo } = referencia;

  if (minimo != null && maximo != null) return `${numero(minimo)} a ${numero(maximo)}`;
  if (minimo != null) return `a partir de ${numero(minimo)}`;
  if (maximo != null) return `até ${numero(maximo)}`;
  return '—';
}

/** "Canino · fêmea · 0–12 meses". Só mostra o que foi preenchido. */
export function descreverPublico(referencia: ReferenciaResponse): string {
  const partes: string[] = [ROTULO_ESPECIE[referencia.especie as Especie] ?? referencia.especie];

  if (referencia.sexo) partes.push(ROTULO_SEXO[referencia.sexo as Sexo].toLowerCase());

  const { idadeMinMeses: min, idadeMaxMeses: max } = referencia;
  if (min != null && max != null) partes.push(`${min}–${max} meses`);
  else if (min != null) partes.push(`a partir de ${min} meses`);
  else if (max != null) partes.push(`até ${max} meses`);

  return partes.join(' · ');
}
